export default __webpack_public_path__ + "81d38ae7fb2abf5b70081cece8bce1ab.woff2";